import makeStyles from '@mui/styles/makeStyles';
import React, { useCallback } from 'react';
import { texts } from 'utils/languages/fr';
import { MemoizedTextField } from '../memoized-components/MemoizedComponents';

const useStyles = makeStyles(theme => ({
    field: { width: '100%', maxWidth: theme.constants.tunnelInputWidth },
}));

const FaxForm = ({ fax, onChange }) => {
    const classes = useStyles();

    const handleChange = useCallback(
        e => {
            const { name, value } = e.target;
            onChange(name, value);
        },
        [onChange]
    );

    return (
        <MemoizedTextField
            name="fax"
            inputStyle={classes.field}
            label={texts.FAX}
            value={fax}
            onChange={handleChange}
        />
    );
};

export default FaxForm;
